export const PAGE_LOADING = 'PAGE_LOADING'
export const MENU_LOADING = 'MENU_LOADING'
export const UPDATE_CONTENT_LOADING = 'UPDATE_CONTENT_LOADING'
export const UPDATE_RES_MESSAGE = 'UPDATE_RES_MESSAGE'
export const UPDATE_USER = 'UPDATE_USER'